/**
 * @param {Date} day
 *
 * @returns {string}
 */
export function formatMonthDay(day) {
  return String(day.getDate())
}
